import React, { useRef, useState } from "react";

import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { validaSoloNumero } from "../../../util/varios";
import { Mensaje, MensajeSiNo } from "../../mensajes2";

import { Dimmer } from "../../spinner";
/* import CatalogoModelo from '../../catalogos/catalogoModelo'; */
import moment from "moment";
import CatalogoAlmacen from "../../../catalogos/catalogoAlmacen";
/* import CatalogoAlmacen from '../../catalogos/catalogoAlmacen'; */
/* import CatalogoProductosExistencias from '../../catalogos/catalogoProductosExistencias';
 */
export const ImprimirProductos = (props) => {
  var op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
  const afiliado = JSON.parse(localStorage.getItem("riforganizacion"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtInputAlmacen = useRef();
  const txtInputProducto = useRef();
  const txtTodosAlmacen = useRef();
  const txtPorAlmacen = useRef();
  const txtTodosDispo = useRef();
  const txtEnStock = useRef();
  const txtAgotados = useRef();
  const txtTodosProductos = useRef();
  const txtPorProductos = useRef();
  const txtIdProducto = useRef();
  const txtRifrespon = useRef();
  const txtNomrespon = useRef();
  const txtNombreAlmacen = useRef();
  const txtNombreProducto = useRef();
  const txtTipoproducto = useRef();
  const txtMarca = useRef();
  const txtCheckPrecio = useRef();

  const [inputalmacen, setInputalmacen] = useState(0);
  const [inputproducto, setInputproducto] = useState(0);
  const [validaprecio, setValidaprecio] = useState(0);
  const [tipoproducto, setTipoproducto] = useState([]);
  const [mostrar, setMostrar] = useState(null);
  const [mostrar1, setMostrar1] = useState(null);
  const [almacenc, setAlmacenc] = useState("");
  const [disponiblec, setDisponiblec] = useState("");
  const [productoc, setProductoc] = useState("");
  const [idproductos, setIdproductos] = useState("");
  const [idalmacenc, setIdalmacenc] = useState("");
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [habimarcatipopro, setHabimarcatipopro] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [marca, setMarca] = useState([]);
  const [idmarca, setIdmarca] = useState("");
  const [idtproduct, setIdtproduct] = useState("");
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false,
  });

  const blanquear = () => {
    setActivate(false);
    setInputalmacen(0);
    setAlmacenc("");
    setDisponiblec("");
    setProductoc("");
    setInputproducto(0);
    setValidaprecio(0);
    setIdalmacenc("");
    setIdproductos("");
    setIdmarca("");
    setIdtproduct("");
    setHabimarcatipopro(false);
  };

  const cancelar = () => {
    blanquear();
    props.cerrar();
    props.setShow(false);
  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.op === 1) {
      if (
        txtPorAlmacen.current.checked === true &&
        txtPorProductos.current.checked === false
      ) {
        if (txtInputAlmacen.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Introduzca el Almacen a Consultar !",
            icono: "informacion",
          });
          txtInputAlmacen.current.focus();
          sigue = false;
        } else {
          imprimirGeneral();
        }
      } else if (
        txtPorAlmacen.current.checked === false &&
        txtPorProductos.current.checked === true
      ) {
        if (txtInputProducto.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Introduzca el Producto a Consultar !",
            icono: "informacion",
          });
          txtInputProducto.current.focus();
          sigue = false;
        } else {
          imprimirGeneral();
        }
      } else if (
        txtPorAlmacen.current.checked === true &&
        txtPorProductos.current.checked === true
      ) {
        if (txtInputProducto.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Introduzca el Producto a Consultar !",
            icono: "informacion",
          });
          txtInputProducto.current.focus();
          sigue = false;
        } else if (txtInputAlmacen.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Introduzca el Almacen a Consultar !",
            icono: "informacion",
          });
          txtInputAlmacen.current.focus();
          sigue = false;
        } else {
          imprimirGeneral();
        }
      } else {
        imprimirGeneral();
      }
    }
  };

  const onChekval = (e) => {
    if (e.target.id === "tipoalmacen") {
      if (txtTodosAlmacen.current.checked === true) {
        setInputalmacen(0);
        setAlmacenc("");
        setIdalmacenc("");
        txtNomrespon.current.value = "";
        txtRifrespon.current.value = "";
        txtNombreAlmacen.current.value = "";
      } else if (txtPorAlmacen.current.checked === true) {
        setInputalmacen(1);
        setAlmacenc(" and a.idalmacen =");
      }
    } else if (e.target.id === "tipodisponible") {
      if (e.target.value === "1") {
        setDisponiblec("");
      } else if (e.target.value === "2") {
        setDisponiblec(" and e.cantidad > 0.00");
      } else if (e.target.value === "3") {
        setDisponiblec(" and e.cantidad = 0.00");
      }
    } else if (e.target.id === "tipoproducto") {
      if (txtTodosProductos.current.checked === true) {
        setInputproducto(0);
        setProductoc("");
        setIdproductos("");
        setHabimarcatipopro(false);
        txtNombreProducto.current.value = "";
      } else if (txtPorProductos.current.checked === true) {
        setInputproducto(1);
        setHabimarcatipopro(true);
        setProductoc(" and p.idproducto =");
      }
    }

    /*  if (e.target.name === 'valprecio') {
      if (txtCheckPrecio.current.checked === true) {
        setValidaprecio(1);
      } else {
        setValidaprecio(0);
      }
    } */
  };

  const onChange = (e) => {
    if (e.target.name === "tproducto") {
      if (e.target.value === "0") {
        setIdtproduct("");
      } else {
        let valor = " and p.idtipoproducto = " + e.target.value;
        setIdtproduct(valor);
      }
    } else if (e.target.name === "marca") {
      if (e.target.value === "0") {
        setIdmarca("");
      } else {
        let valor = " and p.idfabricante = " + e.target.value;
        setIdmarca(valor);
      }
    }
  };

  const imprimirGeneral = () => {
    var reporte = "";
    let condi =
      almacenc +
      idalmacenc +
      disponiblec +
      productoc +
      idproductos +
      idtproduct +
      idmarca;

    if (validaprecio === 1) {
      reporte = "ListProductoExistenciaDos";
    } else {
      reporte = "ListaProductoExistencia";
    }

    let tipo = 0;

    if (idtproduct !== "" && idmarca !== "") {
      tipo = 3;
    } else if (idtproduct !== "" && idmarca === "") {
      tipo = 1;
    } else if (idtproduct === "" && idmarca !== "") {
      tipo = 2;
    } else {
      tipo = 0;
    }

    window.open(
      op.reportes +
        "/comprasyalmacen?afiliado=" +
        afiliado +
        "&reporte=" +
        reporte +
        "&condicion=" +
        condi +
        "&tipo=" +
        tipo,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    if (props.llamado === 2) {
      props.onHideRenderizar();
      props.setShow(false);
    }
    blanquear();
    props.cerrar();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleAceptaAlmacen = (values) => {
    setMostrar(false);
    selectAlmacen(values);
    setIdalmacenc(values);
  };

  const handleAceptaProducto = (values) => {
    setMostrar1(false);
    txtInputProducto.current.value = values.codigo;
    txtNombreProducto.current.value = values.nombrecorto;
    setIdproductos(values.idproducto);
  };

  const catalogoAlmacenc = (e) => {
    e.preventDefault();
    setMostrar(true);
  };

  const catalogoProductoc = (e) => {
    e.preventDefault();
    setMostrar1(true);
  };

  const selectAlmacen = (id) => {
    let campos = "*";
    let nomtab = "almacen";
    let nomid = "idalmacen";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    //let endpoint = `${op.conexion}/api/inventario/almacenpordescripcion?descripcion=${"'"+descrip.toUpperCase()+"'"}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idalmacen > 0) {
            txtInputAlmacen.current.value = response.data.idalmacen;
            txtNombreAlmacen.current.value = response.data.descripcion;
            setIdalmacenc(response.data.idalmacen);
            selectResponsable(response.data.responsable);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "¡ Código y/o Almacen no Registrado !",
              icono: "error",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectResponsable = (id) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.cedula > 0) {
            txtNomrespon.current.value =
              response.data.nombres.trim() +
              " " +
              response.data.apellidos.trim();
            txtRifrespon.current.value = response.data.cedula;
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarProducto = (id) => {
    let endpoint = `${op.conexion}/api/inventario/productosenexistenciaid?id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idproducto > 0) {
            txtInputProducto.current.value = response.data.codigo;
            txtNombreProducto.current.value = response.data.nombrecorto;
            setIdproductos(response.data.idproducto);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "¡ Código y/o Producto no Registrado !",
              icono: "error",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const handleProducto = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof e.which === "undefined") {
      if (e.target.value !== "") {
        seleccionarProducto("'" + e.target.value.toUpperCase() + "'");
      }
    }
  };

  const handleAlmacen = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof e.which === "undefined") {
      if (e.target.value !== "") {
        selectAlmacen(e.target.value);
      }
    }
  };

  const seleccionarTipoProductos = () => {
    let campos = "idtipoproducto, trim(descripcion) as descripcion";
    let nomtab = "tipoproducto";
    let orden = "idtipoproducto";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let datos = [];

            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].idtipoproducto !== "0") {
                datos.push({
                  idtipoproducto: response.data[i].idtipoproducto,
                  descripcion: response.data[i].descripcion,
                });
              }
            }
            setTipoproducto(datos);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarFabricante = () => {
    let campos = "idfabricante, trim(descripcion) as descripcion";
    let nomtab = "fabricante";
    let orden = "idfabricante";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let datos = [];

            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].idfabricante !== "0") {
                datos.push({
                  idfabricante: response.data[i].idfabricante,
                  descripcion: response.data[i].descripcion,
                });
              }
            }
            setMarca(datos);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.op === 1) {
          txtTodosAlmacen.current.checked = true;
          txtTodosDispo.current.checked = true;
          txtTodosProductos.current.checked = true;
          setAlmacenc("");
          setDisponiblec("");
          setProductoc("");
          seleccionarTipoProductos();
          seleccionarFabricante();
          txtPorAlmacen.current.checked = false;
          txtEnStock.current.checked = false;
          txtAgotados.current.checked = false;
          txtPorProductos.current.checked = false;
          setHabilitado(false);
        } else {
          txtTodosAlmacen.current.checked = false;
          txtTodosDispo.current.checked = false;
          txtTodosProductos.current.checked = false;

          txtPorAlmacen.current.checked = false;
          txtEnStock.current.checked = false;
          txtAgotados.current.checked = false;
          txtPorProductos.current.checked = false;
          setHabilitado(true);
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold" style={{ color: "#fff" }}>
          <h3>Imprimir Lista de Productos</h3>
        </div>

        <a
          href="#"
          ref={btnSalir}
          disabled={botones.salir}
          onClick={cancelar}
          className="text-light"
        >
          <i className="fas fa-times fa-1x shadow"> {/* Salir */}</i>
        </a>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate}></Dimmer>
        <div className="col-md-12 row mx-auto px-0">
          <div className="row col-md-12 rounded mx-auto">
            {/* <div className='col-3 ml-auto'>
              <div className="form-check">
                <input className="form-check-input" ref={txtCheckPrecio} name='valprecio' onChange={onChekval} type="checkbox" value="" id="flexCheckDefault" />
                <label className="form-check-label" for="flexCheckDefault">
                  Solo Precio de Venta
                </label>
              </div>
            </div> */}

            <fieldset className="row col-sm-12 mx-auto border-azul rounded mb-1 pt-3">
              <div className="col-md-12 row mx-auto">
                <label className="col-md-6 fs-5 fw-bold">Almacén:</label>

                <div className="form-check col-3 mx-auto">
                  <input
                    className="form-check-input my-auto"
                    name="tipoalmacen"
                    value="1"
                    ref={txtTodosAlmacen}
                    onChange={onChekval}
                    id="tipoalmacen"
                    type="radio"
                  />
                  <label
                    className="form-check-label my-auto"
                    for="exampleRadi1"
                  >
                    Todos
                  </label>
                </div>

                <div className="form-check col-3 mx-auto">
                  <input
                    className="form-check-input my-auto"
                    name="tipoalmacen"
                    value="2"
                    ref={txtPorAlmacen}
                    onChange={onChekval}
                    id="tipoalmacen"
                    type="radio"
                  />
                  <label
                    className="form-check-label my-auto"
                    for="exampleRadi2"
                  >
                    Por Almacen
                  </label>
                </div>
              </div>

              {inputalmacen === 1 ? (
                <div className="input-group input-group-sm col-12 px-0 mt-1 mb-1">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Código Almacén:
                  </label>
                  <input
                    type="text"
                    ref={txtInputAlmacen}
                    disabled={inputalmacen === 1 ? false : true}
                    onKeyUp={handleAlmacen}
                    onBlur={handleAlmacen}
                    className="form-control text-uppercase col-md-1"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                  <button
                    disabled={inputalmacen === 1 ? false : true}
                    type="button"
                    onClick={catalogoAlmacenc}
                    className="btn btn-success"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                  <input
                    type="text"
                    ref={txtNombreAlmacen}
                    disabled={true}
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              ) : (
                ""
              )}

              {inputalmacen === 1 ? (
                <div className="col-12 row m-auto px-0 mb-0">
                  <div className="input-group input-group-sm col-9 px-0">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Responsable:
                    </label>
                    <input
                      type="text"
                      ref={txtNomrespon}
                      disabled={true}
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div className="input-group input-group-sm col-3 px-0">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Cédula:
                    </label>
                    <input
                      type="text"
                      ref={txtRifrespon}
                      disabled={true}
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </fieldset>

            <fieldset className="row col-sm-12 mx-auto border-azul rounded mb-1 pt-3">
              <label className="col-md-3 fs-5 fw-bold">Disponibilidad:</label>

              <div className="form-check col-2 mx-auto">
                <input
                  className="form-check-input my-auto"
                  name="tipodisponible"
                  value="1"
                  ref={txtTodosDispo}
                  onChange={onChekval}
                  id="tipodisponible"
                  type="radio"
                />
                <label className="form-check-label my-auto" for="exampleRai1">
                  Todos
                </label>
              </div>

              <div className="form-check col-3 mx-auto">
                <input
                  className="form-check-input my-auto"
                  name="tipodisponible"
                  value="2"
                  ref={txtEnStock}
                  onChange={onChekval}
                  id="tipodisponible"
                  type="radio"
                />
                <label className="form-check-label my-auto" for="exampleRai2">
                  En Existencia
                </label>
              </div>

              <div
                className="form-check col-3"
                style={{
                  display: "none",
                }}
              >
                <input
                  className="form-check-input my-auto"
                  name="tipodisponible"
                  value="3"
                  ref={txtAgotados}
                  onChange={onChekval}
                  id="tipodisponible"
                  type="radio"
                />
                <label className="form-check-label my-auto" for="exampleRai3">
                  Agotados
                </label>
              </div>
            </fieldset>

            <fieldset className="row col-sm-12 mx-auto border-azul rounded mb-1 pt-3">
              <label className="col-md-6 fs-5 fw-bold">Producto:</label>

              <div
                className="form-check col-3 mx-auto"
                style={{
                  display: "none",
                }}
              >
                <input
                  className="form-check-input my-auto"
                  name="tipoproducto"
                  value="1"
                  ref={txtTodosProductos}
                  onChange={onChekval}
                  id="tipoproducto"
                  type="radio"
                />
                <label className="form-check-label my-auto" for="exampleRa1">
                  Todos
                </label>
              </div>

              <div
                className="form-check col-3 mx-auto"
                style={{
                  display: "none",
                }}
              >
                <input
                  className="form-check-input my-auto"
                  name="tipoproducto"
                  value="2"
                  ref={txtPorProductos}
                  onChange={onChekval}
                  id="tipoproducto"
                  type="radio"
                />
                <label className="form-check-label my-auto" for="exampleRa2">
                  Por Producto
                </label>
              </div>

              <input type="hidden" ref={txtIdProducto} />

              {inputproducto === 1 ? (
                <div className="input-group input-group-sm col-md-12 px-0 mb-1">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Código:
                  </label>
                  <input
                    type="text"
                    ref={txtInputProducto}
                    disabled={inputproducto === 1 ? false : true}
                    onKeyUp={handleProducto}
                    onBlur={handleProducto}
                    className="form-control text-uppercase col-md-1"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                  <button
                    disabled={inputproducto === 1 ? false : true}
                    type="button"
                    onClick={catalogoProductoc}
                    className="btn btn-success"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                  <input
                    type="text"
                    ref={txtNombreProducto}
                    disabled={true}
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              ) : (
                ""
              )}

              {/*   {inputproducto === 1 ? <div className='col-12 row m-0 mb-1 py-1'>

                <div className='col-12'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">Nombre del Producto:</label>
                   
                  </div>
                </div>

              </div> : ''} */}

              <div className="col-12 row mx-auto px-0">
                <div className="input-group input-group-sm mb-1 col-md-6 px-0">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Tipo Producto:
                  </label>
                  <select
                    ref={txtTipoproducto}
                    name="tproducto"
                    onChange={onChange}
                    className="form-select form-select-sm text-center"
                    disabled={habimarcatipopro}
                    aria-label=".form-select-sm example"
                  >
                    <option value="0">TODOS</option>
                    {tipoproducto &&
                      tipoproducto.map((item, index) => (
                        <option key={index} value={item.idtipoproducto}>
                          {" "}
                          {item.descripcion}{" "}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="input-group input-group-sm mb-1 col-md-6 px-0">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    FABRICANTE:
                  </label>
                  <select
                    ref={txtMarca}
                    name="marca"
                    onChange={onChange}
                    className="form-select form-select-sm text-center"
                    disabled={habimarcatipopro}
                    aria-label=".form-select-sm example"
                  >
                    <option value="0">TODOS</option>
                    {marca &&
                      marca.map((item, index) => (
                        <option key={index} value={item.idfabricante}>
                          {" "}
                          {item.descripcion}{" "}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className="col-md-4 ml-auto px-0 m-0 d-flex justify-content-end">
            <button
              ref={btnAcepta}
              disabled={habilitado}
              onClick={onChangeValidar}
              className="btn btn-sm rounded-pill btn-primary mx-1"
            >
              <i className="fas fa-print"> Imprimir</i>
            </button>
            <button
              ref={btnCancela}
              onClick={cancelar}
              className="btn btn-danger btn-sm rounded-pill mx-1"
            >
              <i className="fas fa-window-close"> Cancelar</i>
            </button>
          </div>
        </div>
      </Modal.Footer>
      <CatalogoAlmacen
        show={mostrar}
        onHideCancelar={() => setMostrar(false)}
        onHideAceptaCatalogo={handleAceptaAlmacen}
      />
      {/*  <CatalogoProductosExistencias
        show={mostrar1}
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaCatalogo={handleAceptaProducto}
      /> */}
    </Modal>
  );
};
